import { useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';

interface AnimatedCounterProps {
  value: number;
  animationLength?: number;
  frames?: number;
}

const AnimatedCounter = ({
  value = 0,
  animationLength = 1000,
  frames = 77,
}: AnimatedCounterProps) => {
  const [currentValue, setCurrentValue] = useState<number>(0);
  const [hasAnimated, setHasAnimated] = useState(false);

  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  useEffect(() => {
    if (!inView || hasAnimated) return;

    const start = 0;
    const end = value;
    const frameDuration = animationLength / frames;
    const increment = (end - start) / frames;

    let current = start;
    const timer = setInterval(() => {
      current += increment;
      const shouldClear = increment > 0 ? current >= end : current <= end;

      setCurrentValue(shouldClear ? end : current);

      if (shouldClear) {
        clearInterval(timer);
        setHasAnimated(true);
      }
    }, frameDuration);

    return () => clearInterval(timer);
  }, [inView, hasAnimated, value, animationLength, frames]);

  return (
    <div ref={ref}>
      {Math.round(currentValue)}
    </div>
  );
};

export default AnimatedCounter;
